// src/services/api.js
import axios from 'axios';

/*onst api = axios.create({
    //baseURL: 'https://booking-backend-3897450fe5a2.herokuapp.com/api/properties',
    //baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api', // version locale par défaut
    //baseURL: 'http://localhost:5000/api', // version déployée sur Render
    baseURL: 'https://mbs-app-immo-back.onrender.com/api', // version déployée sur Render
    //baseURL: 'https://mbs-app-immo-back.onrender.com/api' || 'http://localhost:5000/api', // version déployée sur Render
    // timeout: 5000, // optionnel : timeout des requêtes
    // headers: { Authorization: 'Bearer xyz' } // si tu veux injecter un token plus tard
});*/

const baseURL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:7100/api";

const api = axios.create({
  baseURL,
});

export default api;